import { canonicalAssetLanguage } from "./vod-title";
import { DEFAULT_IMAGE_TYPE } from "./vod-images";
export const FEED_SYNOPSIS_MEDIUM_MAX = 400;
export const FEED_SYNOPSIS_SHORT_MAX = 140;
export const FEED_TEXT_LANGUAGE_FALLBACK = "en";
export function truncateSynopsis(text, max) {
    const trimmed = text.trim();
    if (trimmed.length <= max)
        return trimmed;
    const cut = trimmed.slice(0, max);
    const lastSpace = cut.lastIndexOf(" ");
    return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trim()}…`;
}
export function planFeedAsset(supplierId, item, edits = {}) {
    var _a, _b, _c, _d, _e, _f;
    const title = ((_a = edits.title) !== null && _a !== void 0 ? _a : item.title).trim();
    const synopsisLong = ((_b = edits.synopsisLong) !== null && _b !== void 0 ? _b : item.description).trim();
    const synopsisMedium = ((_c = edits.synopsisMedium) !== null && _c !== void 0 ? _c : truncateSynopsis(synopsisLong, FEED_SYNOPSIS_MEDIUM_MAX)).trim();
    const synopsisShort = ((_d = edits.synopsisShort) !== null && _d !== void 0 ? _d : truncateSynopsis(synopsisLong, FEED_SYNOPSIS_SHORT_MAX)).trim();
    const language = canonicalAssetLanguage(item.language);
    const textLanguage = language !== null && language !== void 0 ? language : FEED_TEXT_LANGUAGE_FALLBACK;
    const asset = {
        type: "movie",
        sourceType: "vod",
        externalId: `mrss:${supplierId}:${item.guid}`,
        originalTitle: title,
        provider: { providerId: supplierId },
        keywords: item.keywords,
        localizedInfo: [
            {
                language: textLanguage,
                title,
                synopsisLong,
                synopsisMedium,
                synopsisShort,
            },
        ],
        ...(item.durationSeconds != null ? { duration: item.durationSeconds } : {}),
        ...(language ? { originalLanguage: language } : {}),
    };
    return {
        asset,
        poster: item.thumbnailUrl
            ? {
                url: item.thumbnailUrl,
                language: textLanguage,
                type: DEFAULT_IMAGE_TYPE,
                width: (_e = item.thumbnailWidth) !== null && _e !== void 0 ? _e : 0,
                height: (_f = item.thumbnailHeight) !== null && _f !== void 0 ? _f : 0,
            }
            : null,
        master: { url: item.mediaUrl, mediaType: item.mediaType },
    };
}
function formatDuration(seconds) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    const clock = h
        ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
        : `${m}:${String(s).padStart(2, "0")}`;
    return `${clock} (${seconds} s)`;
}
export function describeFeedAssetPlan(plan, item, edits = {}) {
    var _a;
    const { asset } = plan;
    const info = asset.localizedInfo[0];
    const synopsisSource = (edited, fromFeed) => edited !== undefined ? "edited" : fromFeed ? "feed" : "derived";
    const rows = [
        {
            key: "originalTitle",
            label: "Title",
            value: asset.originalTitle,
            source: asset.originalTitle === item.title.trim() ? "feed" : "edited",
        },
        {
            key: "localizedInfo.language",
            label: "Text language",
            value: info.language,
            source: item.language ? "feed" : "default",
        },
        {
            key: "localizedInfo.synopsisLong",
            label: "Long synopsis",
            value: info.synopsisLong,
            source: info.synopsisLong === item.description.trim() ? "feed" : "edited",
        },
        {
            key: "localizedInfo.synopsisMedium",
            label: "Medium synopsis",
            value: info.synopsisMedium,
            source: synopsisSource(edits.synopsisMedium, info.synopsisMedium === item.description.trim()),
        },
        {
            key: "localizedInfo.synopsisShort",
            label: "Short synopsis",
            value: info.synopsisShort,
            source: synopsisSource(edits.synopsisShort, info.synopsisShort === item.description.trim()),
        },
    ];
    if (asset.originalLanguage) {
        rows.push({
            key: "originalLanguage",
            label: "Original language",
            value: asset.originalLanguage,
            source: "feed",
        });
    }
    if (asset.duration != null) {
        rows.push({
            key: "duration",
            label: "Duration",
            value: formatDuration(asset.duration),
            source: "feed",
        });
    }
    rows.push({
        key: "keywords",
        label: "Keywords",
        value: ((_a = asset.keywords) === null || _a === void 0 ? void 0 : _a.length)
            ? `${asset.keywords.length}: ${asset.keywords.join(", ")}`
            : "None",
        source: "feed",
    });
    if (plan.poster) {
        const { width, height, url } = plan.poster;
        rows.push({
            key: "images",
            label: "Poster",
            value: `${width && height ? `${width}×${height}` : "Size not stated"} · ${url}`,
            source: "feed",
        });
    }
    rows.push({
        key: "master",
        label: "Video file",
        value: `${plan.master.mediaType || "Type not stated"} · ${plan.master.url}`,
        source: "feed",
    }, {
        key: "provider",
        label: "Provider",
        value: asset.provider.providerId,
        source: "derived",
    }, {
        key: "externalId",
        label: "External id",
        value: asset.externalId,
        source: "derived",
    }, {
        key: "type",
        label: "Asset type",
        value: asset.type,
        source: "default",
    }, {
        key: "sourceType",
        label: "Source type",
        value: asset.sourceType,
        source: "default",
    });
    return rows;
}
